/**
@ngdoc directive
@name calcSumRow

@description
Calculate Sum of properties, albeit subtraction or addition

	calc-sum-row="formModel.timeRecordDailyList[0]" // object with all the properties you wish to subtract or add too.
	calc-sum-row-add="property | property1,property2" //(Optional) Property key or keys of which we collect value or values to ADD
	calc-sum-row-subtract="property | property1,property2" //(Optional) Property key or keys of which we collect value or values to SUBTRACT
	calc-sum-row-result="property" //Property key where to output resultant
	calc-sum-row-decimals="^[0-9]" //(Optional) Number of decimal places for answer. If not present defaults to zero = Integer.

@usage
	http://localhost:8080/testSearch/angularSums
	<!--Adding two fields:
		formModel.timeRecordDailyList[0].durationAdjusted =
		+ formModel.timeRecordDailyList[0].duration
		+ formModel.timeRecordDailyList[0].someOtherAddition -->
	<input type="number" name="durationAdjusted"
		calc-sum-row="formModel.timeRecordDailyList[0]"
		calc-sum-row-add="duration,someOtherAddition"
		calc-sum-row-result="durationAdjusted"
		calc-sum-row-decimals="2" />

	<!--Subtracting one field from another:
		formModel.timeRecordDailyList[0].durationAdjusted =
		+ formModel.timeRecordDailyList[0].duration
		- formModel.timeRecordDailyList[0].absoluteReduction -->
	<input type="number" name="durationAdjusted"
		calc-sum-row="formModel.timeRecordDailyList[0]"
		calc-sum-row-add="duration"
		calc-sum-row-subtract="absoluteReduction"
		calc-sum-row-result="durationAdjusted"
		calc-sum-row-decimals="2" />

	<!-- Adding two fields, Subtracting two fields:
		formModel.timeRecordDailyList[0].durationAdjusted =
		+ formModel.timeRecordDailyList[0].duration
		+ formModel.timeRecordDailyList[0].someOtherAddition
		- formModel.timeRecordDailyList[0].absoluteReduction
		- formModel.timeRecordDailyList[0].someOtherSubtraction -->
	<input type="number" name="durationAdjusted"
		calc-sum-row="formModel.timeRecordDailyList[0]"
		calc-sum-row-add="duration,someOtherAddition"
		calc-sum-row-subtract="absoluteReduction,someOtherSubtraction"
		calc-sum-row-result="durationAdjusted"
		calc-sum-row-decimals="2" />

*/
(function() {
	'use strict';

	var calcSumRow = function(mathService) {
		return {
			restrict: "A",
			scope: true,
			bindToController: {
			   rowObject: "=calcSumRow",
			   addPropList: "@calcSumRowAdd", //may be a list or a single property
			   subtractPropList: "@calcSumRowSubtract", //may be a list or a single property
			   result: "@calcSumRowResult",
			   decimals: "@calcSumRowDecimals" //Deals with errors like 0.5 - 0.33 = 0.16999999999999998
			},
			controllerAs: 'ctrl',
			controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
				var DEBUG = false;
				var _this = this;
				if(DEBUG) {
					console.log('calcSumRow() running...',_this.rowObject);
				}

				var decimals;
				_this.$onInit = function(){
					//set decimals or use default of zero
					decimals = angular.isDefined(_this.decimals) ? _this.decimals : 0;
				}

				//watch for changes in row
				$scope.$watch(
					function(){
						return (_this.rowObject);
					},
					function(newObject, oldObject){
						if(newObject!=oldObject) { //handle changes in row
							var result = 0;
							if( angular.isDefined(_this.addPropList) ){
								var addPropList = _this.addPropList.split(',');
								angular.forEach(addPropList, function(addProperty){
									result += mathService.roundFromString( newObject[addProperty], decimals );
								});
							}
							if( angular.isDefined(_this.subtractPropList) ){
								var subtractPropList = _this.subtractPropList.split(',');
								angular.forEach(subtractPropList, function(subtractProperty){
									result -= mathService.roundFromString( newObject[subtractProperty], decimals );
								});
							}
							_this.rowObject[_this.result] = mathService.round( result, decimals );

							if(DEBUG) {
								console.log('calcSumRow() change occurred', _this.rowObject[_this.result]);
							}
						}
					},
					true
				);
			}],
			replace: false,
			transclude: false
		};
	}
	calcSumRow.$inject = ['mathService'];
	angular.module('app').directive('calcSumRow', calcSumRow);

}());
